<div class="Bags20kgOnlyWebAppModal bg-am-medium-blue text-am-white d-flex align-items-center flex-column justify-content-center">
  <button
    class="Bags20kgOnlyWebAppModal-close text-am-white"
    (click)="onClose()">
    <i class="far fa-times-circle fs-64px fw-lighter"></i>
  </button>
  <div class="Bags20kgOnlyWebAppModal-image d-flex position-relative bg-white">
    <img class="" src="./assets/images/menuPassenger_bagSelection.png" alt="Bags">
    <img class="" src="./assets/images/alertCircleBlue.svg" alt="Symbol">
  </div>
  <p class="fs-52px text-center fw-medium lh-58px my-4">
    {{ 'modal20KgOnlyWeb.message' | translate }}
  </p>
  <div class="w-100">
    <button
      class="Bags20kgOnlyWebAppModal-button btn btn-light w-100"
      (click)="onClose()"
    >
      {{ 'modalPremierDisclaimer.button' | translate}}
    </button>
  </div>
</div>